module.exports = __webpack_public_path__ + "img/img_level_14.a13bbde7.png";